import { API_BASE_URL } from "./constants";
import { PropQueryDesc } from "../common/model/ssr/requestParameter";
import { TestConnectionPropDesc, WebhookPropDesc } from "../common/model/webhookResponse";
import { ApiObject, PropDesc } from "../common/model/objectTypes";

export const generateCurlCommand = (
  url: string,
  method: string,
  requestBody: any
): string => {
  return `curl -v -X ${method} ${API_BASE_URL}/${url}
    -H 'Authorization: Bearer <Access Token>'
    -H 'x-api-key: <API Key>'
    -H 'Content-Type: application/json'
    -d '${JSON.stringify(requestBody, null, 2)}'`;
};

export const generateCallbackCurlCommand = (
  url: string,
  method: string,
  requestBody: any
): string => {
  return `curl -v -X ${method} ${API_BASE_URL}/${url}
    -H 'Authorization: Bearer <Access Token>'
    -H 'x-api-key: <API Key>'
    -H 'Content-Type: application/json'
    -H 'callback-api-key: x-api-key'
    -d '${JSON.stringify(requestBody, null, 2)}'`;
};

export const generateNoBodyCurlCommand = (
  url: string,
  method: string,
): string => {
  return `curl -v -X ${method} ${API_BASE_URL}/${url}
    -H 'Authorization: Bearer <Access Token>'
    -H 'x-api-key: <API Key>'
    -H 'Content-Type: application/json'`;
};

export const createPropDesc = (
  name: string,
  required: boolean,
  fieldType: string,
  description: string
): PropDesc => ({
  name,
  required,
  fieldType,
  description,
});

export const createPropQueryDesc = (
  name: string,
  required: boolean,
  fieldType: string,
  description: string,
  queryIn: string
): PropQueryDesc => ({
  name,
  required,
  fieldType,
  description,
  in: queryIn,
});

export const createWebhookPropDesc = (
  name: string,
  fieldType: string,
  description: string,
): WebhookPropDesc => ({
  name,
  fieldType,
  description,
});

export const createTestConnectionPropDesc = (
  eventType: string,
  DataType: string,
  Description: string,
): TestConnectionPropDesc => ({
  eventType,
  DataType,
  Description,
});

export const createApiDescription = (
  apiInfo: string,
  apiSpecifications: string[]): ApiObject => ({ apiInfo, apiSpecifications });

export const containsInKey = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key].hasOwnProperty("in")) {
      return true
    }
  }
  return false
}

export function getAccordionTitleClassName(level: string, panelId: string) {
  let classNames = ['accordion-title'];

  if (level === 'root') {
    classNames.push('root-level');
  }

  if (
    level === 'root-REST APIs' ||
    level === 'root-Webhooks'
  ) {
    classNames.push('root-level1');
  }

  if (level.includes('root-REST APIs-SafeSend')) {
    classNames.push('root-level2');
  }

  if (level.includes('root-REST APIs-Guides')) {
    classNames.push('rest-apis-guides-child');
  }

  if (level.includes('root-Webhooks-SafeSend')) {
    classNames.push('root-webhooks-level1');
  }

  if (level.includes('root-REST APIs-Authentication')) {
    classNames.push('.rest-API-authentication');
  }

  return classNames.join(' ');
}
